import { type ReactNode, useEffect } from "react";

import { useTranslation } from "react-i18next";
import { trackPromise } from "react-promise-tracker";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router";

import { getStrapiClient } from "@/lib/strapiClient";

import TopBar from "./topBar";
import { getSessionStorageFor } from "../lib/http/cookies";
import type { RootState } from "../redux/store";
import { setUser } from "../redux/userSlice";

type Props = {
	children: ReactNode | ReactNode[];
};

export default function Layout({ children }: Props) {
	const { i18n } = useTranslation();
	const [searchParams] = useSearchParams();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const userState = useSelector((state: RootState) => state.user);

	useEffect(() => {
		const fetchUser = async () => {
			if (getSessionStorageFor("token")) {
				const client = getStrapiClient();
				const response = await client.fetch("users/me");
				const user = await response.json();
				dispatch(setUser(user));
				if (window.location.pathname.includes("login")) {
					navigate("/accidents");
				}
			}
		};

		trackPromise(fetchUser());
	}, [dispatch, navigate]);

	useEffect(() => {
		const lang = searchParams.get("lang");
		if (lang) {
			console.info("LANG: ", lang);
			i18n.changeLanguage(lang);
		}
	}, [i18n, searchParams]);

	return window.location.pathname.includes("login") || !userState.loggedIn ? (
		<div className="flex h-screen flex-col">{children}</div>
	) : (
		<div className="flex h-screen flex-col">
			<TopBar />
			{children}
		</div>
	);
}
